// src/Component/Toast/SuccessToast.js
import AppToast from './AppToast';

const SuccessToast = (props) => <AppToast type="success" delay={1000} {...props} />;
export default SuccessToast;